import { jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { N as NotificationBadge } from "./NotificationBadge.js";
import { IconSize, AnalyticsId } from "./constants.js";
import badgeStyles from "./components/Badge/styles.module.scss";
const Badge = React.forwardRef(function BadgeForwardedRef(props, ref) {
  const { children, className = "", color = "blueberry", testId, type = "string", notificationVariant = "info" } = props;
  const badgeClasses = classNames(
    badgeStyles.badge,
    {
      [badgeStyles["badge--blueberry"]]: color === "blueberry",
      [badgeStyles["badge--cherry"]]: color === "cherry",
      [badgeStyles["badge--neutral"]]: color === "neutral"
    },
    className
  );
  if (type === "notification" && notificationVariant !== void 0) {
    return /* @__PURE__ */ jsx(
      NotificationBadge,
      {
        variant: notificationVariant,
        size: IconSize.XSmall,
        className,
        testId,
        "data-analyticsid": AnalyticsId.Badge
      }
    );
  }
  return /* @__PURE__ */ jsx("span", { className: badgeClasses, ref, "data-testid": testId, "data-analyticsid": AnalyticsId.Badge, children });
});
export {
  Badge as B
};
//# sourceMappingURL=Badge.js.map
